import { createContext, useContext } from 'react';
import noop from 'utils/noop';
import { UserDataLevel } from '../constants';

export interface DynamicHeatmapContextState {
  messageContent: string;
  onLoadUserData: (str: string) => void;
  isLoading: boolean;
  setUserData: (str: string) => void;
  userData: string;
  userList: any[];
  isCustomDataCheck: () => boolean;
  userId: string;
  setUserId: (str: string) => void;
  userCount: number;
  setUserPage: (num: number) => void;
  userPage: number;
  dataFeedContent: string;
  dataFeedNames: string[];
  loadUser: (str: string) => void;
  isFullscreen: boolean;
  setIsFullscreen: (bool: boolean) => void;
  dynamicLinkStats: any[];
  rawLinkData: any[];
  setDynamicLinkStats: (val: any[]) => void;
  setRawLinkData: (val: any[]) => void;
  campaignId: string;
  templateId: string;
  contentId: string;
  augmentedLinkData: any[];
  setAugmentedLinkData: (val: any[]) => void;
  templateUrlData: any[];
  setTemplateUrlData: (val: any[]) => void;
  userDataLevel: UserDataLevel;
  loadedIframe: number;
  setLoadedIframe: (num: number) => void;
  hasLegacyAndDynamicClicks: boolean;
  showLegacy: boolean;
  setShowLegacy: (val: boolean) => void;
  hoveredTooltipKey: string;
  setHoveredTooltipKey: (val: string) => void;
  hasTrackingErrors: boolean;
}

export const initialDynamicHeatmapContextState = {
  messageContent: '',
  onLoadUserData: noop,
  isLoading: false,
  setUserData: noop,
  userData: '{}',
  userList: [],
  isCustomDataCheck: () => false,
  userId: '',
  setUserId: noop,
  userCount: -1,
  setUserPage: noop,
  userPage: 1,
  dataFeedContent: '{}',
  dataFeedNames: [],
  loadUser: noop,
  isFullscreen: false,
  setIsFullscreen: noop,
  dynamicLinkStats: [],
  rawLinkData: [],
  setDynamicLinkStats: noop,
  setRawLinkData: noop,
  campaignId: '',
  templateId: '',
  contentId: '',
  augmentedLinkData: [],
  setAugmentedLinkData: noop,
  templateUrlData: [],
  setTemplateUrlData: noop,
  userDataLevel: UserDataLevel.Restricted,
  loadedIframe: 0,
  setLoadedIframe: noop,
  hasLegacyAndDynamicClicks: false,
  showLegacy: false,
  setShowLegacy: noop,
  hoveredTooltipKey: '',
  setHoveredTooltipKey: noop,
  hasTrackingErrors: false,
};

export const DynamicHeatmapContext = createContext<DynamicHeatmapContextState>(
  initialDynamicHeatmapContextState,
);

export const useDynamicHeatmapContext = () => useContext(DynamicHeatmapContext);
